<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle id="Selected Border" cx="25" cy="25" r="24" stroke="#254B86" stroke-linecap="round"/>
</svg>
